import { RestService } from '../restService';
import { Task } from '../../models';

export class TaskService extends RestService<Task> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }

    public async getBySession(sessionId: string): Promise<Task[]> {
        const realClient = await this.axiosFactory();
        const response = await realClient.request<Task[]>({
            method: 'GET',
            url: `session/${sessionId}`,
        });

        return response?.data ?? [];
    }
}
